import React, {useState} from 'react';
import {Pills} from '@homeaway/landing-presentational';
import {pushEdapEvent, getRefinements} from '../../../utils/edap';

export function sendToEdap(actionlocation, refinementKey, position) {
    const mainData = {
        actionlocation,
        eventrefinements: getRefinements({
            refinementKey,
            position,
            forceAddRefinementKey: true,
        }),
    };
    pushEdapEvent('refinement.click', mainData);
}

export function FilterPill(props) {
    const {filters, onSelection, actionlocation, initialFilter} = props;

    const [activeFilter, setActiveFilter] = useState(initialFilter);

    if (!(filters && filters.length)) {
        return null;
    }

    function clickHandler(filterKey, position) {
        if (activeFilter === filterKey) {
            return;
        }

        onSelection(filterKey);
        setActiveFilter(filterKey);
        sendToEdap(actionlocation, filterKey, position);
    }

    const items = filters.map((f, idx) => ({
        label: f.label,
        id: f.id,
        handler: () => clickHandler(f.id, idx + 1),
    }));

    return <Pills items={items} activeKey={activeFilter} />;
}

FilterPill.displayName = 'FilterPill';

export default FilterPill;
